module.exports = __webpack_public_path__ + "static/media/phone1.3f455fd7.png";